// src/pages/AgentManagement/AgentPagination.tsx
// Pagination component for agents list

import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('agent_management');

interface AgentPaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
}

const AgentPagination: React.FC<AgentPaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;
  
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);
  
  const getPageNumbers = () => {
    const pages: number[] = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      
      if (currentPage > 3) {
        pages.push(-1); // Ellipsis
      }
      
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      
      if (currentPage < totalPages - 2) {
        pages.push(-1); // Ellipsis
      }
      
      pages.push(totalPages);
    }
    
    return pages;
  };
  
  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="text-muted">
        {st('hien_thi_text')} {startItem} - {endItem} {st('trong_tong_so_text')} {totalItems} {st('dai_ly_text')}
      </div>
      
      <Pagination className="pagination-rounded mb-0">
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            onClick={() => onPageChange(currentPage - 1)}
          >
          <i className="ri-arrow-left-line"></i>
          </PaginationLink>
        </PaginationItem>
        
        {getPageNumbers().map((page, index) =>
          page === -1 ? (
            <PaginationItem disabled key={`ellipsis-${index}`}>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          ) : (
            <PaginationItem active={page === currentPage} key={page}>
              <PaginationLink onClick={() => onPageChange(page)}>
                {page}
              </PaginationLink>
            </PaginationItem>
          )
        )}
        
        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            onClick={() => onPageChange(currentPage + 1)}
          >
          <i className="ri-arrow-right-line"></i>
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default AgentPagination;